import ReceiptRow from "./ReceiptRow";
import styles from "../styles/receipt.module.css";

export default function TableBody({
  receipts,
  onEdit,
  onDelete,
  onEmail,
  selectedIds = new Set(),
  onToggleSelect,
}) {
  return (
    <div className={`${styles["table-body"]} ${styles["table-responsive"]}`}>
      <table>
        <thead>
          <tr>
            <th style={{ width: 36, paddingRight: 0 }}></th>
            <th>Recibo</th>
            <th>Filial</th>
            <th className="text-end">Monto</th>
            <th>Fecha</th>
            <th>Método</th>
            <th>Cuenta</th>
            <th className="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {receipts.map((r) => (
            <ReceiptRow
              key={r.id}
              receipt={r}
              onEdit={onEdit}
              onDelete={onDelete}
              onEmail={onEmail}
              selected={selectedIds.has(r.id)}
              onToggleSelect={onToggleSelect}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
